import { render, staticRenderFns } from "./parameters.pug?vue&type=template&id=14b3c42a&lang=pug&"
import script from "./parameters.js?vue&type=script&lang=js&"
export * from "./parameters.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b3c42a')) {
      api.createRecord('14b3c42a', component.options)
    } else {
      api.reload('14b3c42a', component.options)
    }
    module.hot.accept("./parameters.pug?vue&type=template&id=14b3c42a&lang=pug&", function () {
      api.rerender('14b3c42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminGAGLayout/views/parameters/index.vue"
export default component.exports